const moment = require('moment');

export default {
  methods: {
    selected(startDate, endDate) {
      for (let i = 0; i < this.dates.length; i++) {
        if (this.dates[i].start === startDate && this.dates[i].end === endDate) {
          return JSON.parse(JSON.stringify(this.dates[i]));
        }
      }
      return {
        title: 'Custom Dates',
        start: startDate,
        end: endDate,
      };
    },
  },
  filters: {
    intervalLabel(date) {
      if (date.title === 'Custom Dates') {
        return moment(date.start, 'MM/DD/YYYY').format('MMM D, YY') + ' - ' +
          moment(date.end, 'MM/DD/YYYY').format('MMM D, YY');
      }
      return date.title;
    },
  },
  data() {
    return {
      dates: [
        {
          title: 'Today',
          start: moment().format('MM/DD/YYYY'),
          end: moment().format('MM/DD/YYYY'),
        },
        {
          title: 'Last 7 Days',
          start: moment().subtract(6, 'days').format('MM/DD/YYYY'),
          end: moment().format('MM/DD/YYYY'),
        },
        {
          title: 'Last 30 Days',
          start: moment().subtract(29, 'days').format('MM/DD/YYYY'),
          end: moment().format('MM/DD/YYYY'),
          active: true,
        },
        {
          title: 'Last 90 Days',
          start: moment().subtract(89, 'days').format('MM/DD/YYYY'),
          end: moment().format('MM/DD/YYYY'),
        },
        {
          title: 'Last 12 Months',
          start: moment().subtract(12, 'months').format('MM/DD/YYYY'),
          end: moment().format('MM/DD/YYYY'),
        },
        {
          title: 'Last Year',
          start: moment().
            subtract(1, 'years').
            startOf('year').
            format('MM/DD/YYYY'),
          end: moment().
            subtract(1, 'years').
            endOf('year').
            format('MM/DD/YYYY'),
        },
        {
          title: 'This Week',
          start: moment().startOf('week').format('MM/DD/YYYY'),
          end: moment().format('MM/DD/YYYY'),
        },
        {
          title: 'This Month',
          start: moment().startOf('month').format('MM/DD/YYYY'),
          end: moment().format('MM/DD/YYYY'),
        },
        {
          title: 'This Year',
          start: moment().startOf('year').format('MM/DD/YYYY'),
          end: moment().format('MM/DD/YYYY'),
        },
        // {
        //   title: 'Custom Dates',
        //   custom: true,
        // },
      ],
    };
  },

};
